module.exports = __webpack_public_path__ + "static/media/LeadGenBoth.401943a2.png";